import { t } from '../../i18n/idioma';
import { IconeHud } from './icones';
import { SubCacada, type PopId } from './BarraTopo';
import { MarcaUltimaIdle } from '../icones/IconesV3';

/* HUD V3: Caçar no meio, em botão redondo com a marca */
const NAV_CEL: ReadonlyArray<{ id: string; rotulo: string; pop?: PopId; abre?: 'cacar' }> = [
  { id: 'cidade', rotulo: 'hud.nav.cidade', pop: 'cidade' },
  { id: 'chat', rotulo: 'hud.nav.chat' },
  { id: 'cacar', rotulo: 'mundo.cacar', abre: 'cacar' },
  { id: 'social', rotulo: 'hud.nav.social', pop: 'social' },
  { id: 'mais', rotulo: 'hud.menu.mais', pop: 'mais' }
];

export function NavCelular({
  pop, huntAberto, chatAberto, pipChat, pipSocial, pipMais = false, cacandoDesde, onCacar, onPop, onChat
}: {
  pop: PopId | null;
  huntAberto: boolean;
  chatAberto: boolean;
  pipChat: boolean;
  pipSocial: boolean;
  /** Carta nova no correio ou chamado de suporte esperando: o ponto no Mais. */
  pipMais?: boolean;
  cacandoDesde: string | null;
  onCacar(): void;
  onPop(id: PopId): void;
  onChat(): void;
}) {
  const ligado = (id: string) => {
    if (id === 'cacar') return huntAberto;
    if (id === 'chat') return chatAberto;
    if (id === 'cidade' || id === 'social' || id === 'mais') return pop === id;
    return false;
  };
  const pip = (id: string) => (id === 'chat' && pipChat) || (id === 'social' && pipSocial) || (id === 'mais' && pipMais);
  return (
    <nav className="p-navcel" aria-label={t('mundo.paineis')}>
      {NAV_CEL.map(n => (
        <button
          type="button"
          className="p-nb"
          data-cel={n.id}
          aria-pressed={ligado(n.id)}
          key={n.id}
          onClick={() => {
            if (n.abre) onCacar();
            else if (n.id === 'chat') onChat();
            else if (n.pop) onPop(n.pop);
          }}
        >
          {pip(n.id) && <span className="kit-pip kit-pip--dot p-pip" aria-hidden="true" />}
          {n.id === 'cacar' ? <MarcaUltimaIdle /> : <IconeHud nome={n.id} />}
          <span>{t(n.rotulo)}</span>
          {n.id === 'cacar' && <SubCacada desde={cacandoDesde} curto />}
        </button>
      ))}
    </nav>
  );
}
